if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    if (!details) return;
    const summary = details.querySelector('summary');
    let closeTimeout;

    menu.addEventListener('mouseenter', () => {
      window.clearTimeout(closeTimeout);
      if (!details.open) details.open = true;
    });

    menu.addEventListener('mouseleave', () => {
      closeTimeout = window.setTimeout(() => {
        details.open = false;
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });
  });
}
